import styled from 'styled-components'

export const Container = styled.div`
  height: ${({ size }) => size}px;
  width: ${({ size }) => size}px;
  margin: ${({ withProgressBar }) => (withProgressBar ? '13px' : '0')};
  position: relative;
`

export const Avatar = styled.img`
  height: ${({ size }) => size}px;
  width: ${({ size }) => size}px;
  border-radius: 50%;
`

export const Accessory = styled.img`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: ${({ size }) => Math.round(size * 1.33)}px;
  height: ${({ size }) => Math.round(size * 1.33)}px;
`
